<template>
  <PC v-if="window.width >= 576 && this.$route.path != '/ClassSchedule'" />
  <TableClassSchedule
    v-else-if="window.width >= 576 && this.$route.path == '/ClassSchedule'"
  />
  <Mobile
    v-else-if="window.width < 576 && this.$route.path != '/ClassSchedule'"
  />
</template>

<script>
import PC from "../components/Tables/TablePC";
import Mobile from "../components/Tables/TableMobile";
import TableClassSchedule from "../components/Tables/TableClassSchedule";

export default {
  components: {
    PC,
    Mobile,
    TableClassSchedule,
  },
  data: () => ({
    window: {
      width: 0,
      height: 0,
    },
  }),
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
};
</script>
